import React from 'react'
import {Formik} from 'formik'
import * as yup from 'yup'
import {toast} from 'react-toastify'

import {Typography, Grid} from '@material-ui/core'

import {
  GRID_CONTAINER_SPACING,
  GridItem,
  SectorContainer,
  SaveButton,
  FormikTextField,
} from './common'

const validationSchema = yup.object({
  message1: yup.string(),
  message2: yup.string(),
})

class GreetingMessageSector extends React.Component {
  render() {
    return (
      <SectorContainer>
        <Formik
          enableReinitialize
          initialValues={this.props.value}
          onSubmit={(values, {setSubmitting}) => {
            this.props
              .onSave({
                variables: {
                  projectId: this.props.project.id,
                  messages: [
                    {
                      type: 'TEXT',
                      value: values.message1,
                    },
                    {
                      type: 'TEXT',
                      value: values.message2,
                    },
                  ],
                },
              })
              .then(re => {
                setSubmitting(false)
                toast.success(
                  'บันทึกข้อมูลการตั้งค่าข้อความต้อนรับเรียบร้อยแล้ว',
                  {
                    hideProgressBar: true,
                    position: toast.POSITION.BOTTOM_RIGHT,
                  },
                )
              })
          }}
          validationSchema={validationSchema}
          render={props => {
            const {
              isSubmitting,
              handleSubmit,
              handleChange,
              handleBlur,
              touched,
              errors,
              values,
            } = props
            return (
              <form onSubmit={handleSubmit}>
                <Typography variant="headline" gutterBottom>
                  ตั้งค่าข้อความต้อนรับ
                </Typography>
                <Typography variant="caption" gutterBottom>
                  ข้อความเหล่านี้ จะปรากฎเมื่อลูกค้าแอด LINE@
                  ของร้านเข้ามาครั้งแรกเท่านั้น
                </Typography>
                <Grid container spacing={GRID_CONTAINER_SPACING}>
                  <GridItem item xs={12} sm={12}>
                    <Typography variant="title">ข้อความที่ 1</Typography>
                  </GridItem>
                  <GridItem item xs={12} sm={12}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      name="message1"
                      value={values.message1}
                      disabled={this.props.disabled}
                      label=""
                      placeholder="ตัวอย่าง, (สวัสดีจ้าขอต้อนรับสู่ Deeple ต้องการซื้อสินค้าอะไรบอกได้เลย)"
                      fullWidth
                      multiline
                      maxLength={1024}
                      rows={5}
                    />
                  </GridItem>
                </Grid>
                <Grid container spacing={GRID_CONTAINER_SPACING}>
                  <GridItem item xs={12} sm={12}>
                    <Typography variant="title">ข้อความที่ 2</Typography>
                  </GridItem>
                  <GridItem item xs={12} sm={12}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      name="message2"
                      value={values.message2}
                      disabled={this.props.disabled}
                      label=""
                      placeholder="ตัวอย่าง, (กดแนะนำสินค้าใน Rich menu หรือลองพิมพ์เข้ามาได้เลย)"
                      fullWidth
                      multiline
                      maxLength={1024}
                      rows={5}
                    />
                  </GridItem>
                </Grid>
                <Grid
                  container
                  direction="row-reverse"
                  spacing={GRID_CONTAINER_SPACING}
                >
                  <GridItem item xs={12} sm={3}>
                    <SaveButton
                      type="submit"
                      variant="contained"
                      disabled={isSubmitting || this.props.disabled}
                      fullWidth
                    >
                      Save
                    </SaveButton>
                  </GridItem>
                </Grid>
              </form>
            )
          }}
        />
      </SectorContainer>
    )
  }
}

export default GreetingMessageSector



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/storeSettings/components/GreetingMessageSector.js